import moment from 'moment';

const handleWeeks = (days: number): string => {
  if (days >= 7) {
    const weeks = Math.round(days / 7);

    return weeks > 1 ? weeks + ' weeks' : weeks + ' week';
  }

  return days + ' days';
};

// change relativeTime values in moment
moment.updateLocale('en', {
  relativeTime: {
    M: '%d month',
    MM: '%d months',
    d: '%d day',
    dd: handleWeeks,
    h: '%d hour',
    hh: '%d hours',
    m: '%d min',
    mm: '%d min',
    s: 'now',
    ss: 'now',
    y: '%d year',
    yy: '%d years',
  },
});

/**
 * @param {String} date
 * @param {boolean} hasNoSuffix removes "ago" if true
 */
export function relativeTime(date: Date | string, hasNoSuffix = true): string {
  const momentLastMessageDate = moment(date);

  const diffInMonths = moment().diff(momentLastMessageDate, 'months');
  const diffInMinutes = moment().diff(momentLastMessageDate, 'minutes');

  if (diffInMinutes < 1) {
    return 'now';
  }

  // decide whether show date or moment fromNow, depending on months difference
  return diffInMonths >= 1 && diffInMonths < 12
    ? momentLastMessageDate.format('DD MMM') // format date in 'DD MMM'
    : momentLastMessageDate.fromNow(hasNoSuffix); // get relative time from moment
}
